import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';
import usePackingTypeService from '../../../app/services/hooks/usePackingTypeService';
import { PackingType } from '../../../app/models/PackingType';
import PackingTypeFormContainer from './forms/PackingTypeFormContainer';
import { ServiceResponse } from '../../../app/services/shared/interfaces';


interface Props {
    packingTypeId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}


const PackingTypeEdit = ({ packingTypeId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { editPackingType, updatePackingType, fetchingEditPackingType, fetchingUpdatePackingType } = usePackingTypeService();
    const [packingType, setPackingType] = useState<PackingType>({ name: '', category: '' });
    const [errorFields, setErrorFields] = useState<any>();
    
    
    useEffect(() => {
        edit();
    }, []);


    const edit = () => {

        if (showLoading) showLoading('loading', 'Cargando tipo de empaques...');
        editPackingType(packingTypeId, {
            onSuccess: (response: ServiceResponse) => {
                setPackingType(response.data.packing_type);
                if (hideLoading) hideLoading();

            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();

            },
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Updating packing type...');
        updatePackingType(packingTypeId, packingType, {
            onSuccess: (response) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({ title: 'Success', message: response.message });
                toast.success(response.message);
                onSaved?.();
            },
            onError: (response) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({ title: 'Error', message: response.message });
            },
            onFieldError: (response) => {
                if (hideLoading) hideLoading();
                setErrorFields(response.data);
            },
        });
    };

    return fetchingEditPackingType ? (
        <LazyLoading height="300" />
    ) : (
        <PackingTypeFormContainer
            fetching={fetchingUpdatePackingType}
            action={update}
            cancel={update}
            packingType={packingType}
            setPackingType={setPackingType}
            errorFields={errorFields}
        />
    );
};

export default PackingTypeEdit;